import { setIsMobile, setIsNotMobile } from '../redux/modules/device';

export const getUIAction = userAgent => {
    const isMobile = userAgent.toLowerCase().includes('mobile');
    if(isMobile) return setIsMobile();
    return setIsNotMobile();
};

export default {};